import { ParamMap, Params } from '@angular/router';
import {
  PARTNER_DEAL_STAGES,
  PartnerDealStage,
} from '@interfaces/partners/responses/partner-deal.response';
import { DEAL_TABS, DealTab } from './deal-tabs';

/**
 * Etapa e aba do deal na URL (card 3307, T06): `?stage=gates&tab=economic-analysis`.
 *
 * F5, link copiado e o voltar do navegador reabrem a tela onde a pessoa estava. Sem `stage` vale a
 * etapa atual do deal; sem `tab`, a Visão geral. A URL só guarda a escolha: quem decide se ela vale
 * (etapa futura, etapa interna para o parceiro, aba sem permissão) continua sendo a tela, que já cai
 * no padrão nesses casos (`shownStage` e `resolveShownTab`).
 *
 * O valor de `stage` é um apelido em inglês, e não o valor do enum (`Documentacao`): o enum é do
 * backend e pode mudar de nome; a URL compartilhada não pode.
 */
export const DEAL_STAGE_SLUGS: Record<PartnerDealStage, string> = {
  Registro: 'registration',
  Consentimento: 'consent',
  Documentacao: 'documentation',
  Gates: 'gates',
  Analise: 'analysis',
  Comite: 'committee',
  Cotacao: 'quotation',
  Contratacao: 'contracting',
  Operacao: 'operation',
};

export interface DealUrlState {
  stage: PartnerDealStage | null;
  tab: DealTab;
}

/** Lê a etapa e a aba da URL. Valor desconhecido vira o padrão, sem erro: link velho ou digitado errado. */
export function readDealUrlState(query: ParamMap): DealUrlState {
  const stageSlug = query.get('stage');
  const tab = query.get('tab') as DealTab | null;
  return {
    stage: PARTNER_DEAL_STAGES.find(s => DEAL_STAGE_SLUGS[s] === stageSlug) ?? null,
    tab: tab && DEAL_TABS.includes(tab) ? tab : 'overview',
  };
}

/** Os query params de um estado. O padrão sai da URL (`null`), para o link mais comum ficar limpo. */
export function toDealUrlParams(state: DealUrlState): Params {
  return {
    stage: state.stage ? DEAL_STAGE_SLUGS[state.stage] : null,
    tab: state.tab === 'overview' ? null : state.tab,
  };
}
